import React from "react";
import PageHeader from "../components/PageHeader";
import { ABOUT_IMAGE, STATS, APPROACH } from "../data/mock";
import * as Icons from "lucide-react";
import { CheckCircle2, Target, Eye, Award } from "lucide-react";
import { TestimonialsSection, AccreditationBar } from "../components/Sections";

const AboutPage = () => (
  <>
    <PageHeader
      title="About LIINEX INFORMATION SYSTEMS"
      subtitle="A specialist ISO consulting and certification advisory firm helping enterprises design, implement and sustain world-class management systems."
      crumbs={[{ label: "About" }]}
    />

    <section className="section-pad bg-white">
      <div className="lis-container grid lg:grid-cols-2 gap-12 items-center">
        <img src={ABOUT_IMAGE} alt="About LIS" className="rounded-2xl w-full h-[440px] object-cover shadow-xl" />
        <div>
          <span className="eyebrow">Who We Are</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">Practical, on-ground ISO consulting since 2012</h2>
          <div className="divider-red mt-4" />
          <p className="mt-4 text-slate-600">
            LIINEX INFORMATION SYSTEMS (LIS) is a full-service ISO consulting, training and audit advisory partner. From our Ghaziabad head office, we serve manufacturers, healthcare providers, technology companies, laboratories and food businesses across India and 22+ countries.
          </p>
          <p className="mt-3 text-slate-600">
            Our consultants are IRCA/Exemplar certified, sector-specialised, and have implemented management systems inside real factories, hospitals and data centers   not just on paper.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="stat-card">
                <div className="text-2xl font-extrabold text-brand">{s.value}</div>
                <div className="text-xs text-slate-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className="section-pad bg-slate-50">
      <div className="lis-container grid md:grid-cols-3 gap-6">
        {[
          { icon: Target, title: "Our Mission", text: "To make world-class management systems accessible, practical and value-adding for every organisation we serve." },
          { icon: Eye, title: "Our Vision", text: "To be South Asia's most trusted ISO consulting and training brand   known for outcomes, not paperwork." },
          { icon: Award, title: "Our Values", text: "Integrity, expertise, empathy and outcomes. We measure success by our clients' certification success and business improvement." },
        ].map((v) => (
          <div key={v.title} className="bg-white rounded-2xl p-7 border border-slate-100 card-hover">
            <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
              <v.icon size={22} />
            </div>
            <h3 className="mt-4 text-xl font-semibold text-slate-900">{v.title}</h3>
            <p className="mt-2 text-slate-600 text-sm leading-relaxed">{v.text}</p>
          </div>
        ))}
      </div>
    </section>

    <section id="team" className="section-pad bg-white">
      <div className="lis-container">
        <div className="max-w-2xl">
          <span className="eyebrow">Our Approach</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">How we take you to certification</h2>
          <div className="divider-red mt-4" />
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {APPROACH.map((a) => {
            const Icon = Icons[a.icon] || CheckCircle2;
            return (
              <div key={a.step} className="p-6 rounded-xl border border-slate-100 card-hover">
                <div className="flex items-center justify-between">
                  <span className="text-3xl font-extrabold text-red-100">{a.step}</span>
                  <Icon size={22} className="text-brand" />
                </div>
                <h4 className="mt-3 font-semibold text-slate-900">{a.title}</h4>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{a.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>

    <TestimonialsSection />
    <AccreditationBar />
  </>
);

export default AboutPage;
